/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from "zustand";

type PermissionType = {
  name: string;
  view: boolean | string;
  create: boolean | string;
  update: boolean | string;
  delete: boolean | string;
};

type UserType = {
  company_id: string;
  company_name: string;
  country: string;
  email: string;
  phone: string;
  role_id: string;
  roles: any;
  user_id: any;
  username: any;
};

interface UserInfoState {
  user: UserType | undefined;
  permission: PermissionType[];
  configProcess: boolean;
  activePermission: PermissionType | undefined;
  setUser: (prop: UserType | undefined) => void;
  setActivePermission: (prop: PermissionType) => void;
}

export const useUserInfo = create<UserInfoState>((set) => ({
  user: undefined,
  permission: [],
  activePermission: undefined,
  configProcess: true,
  setActivePermission: (value) =>
    set(() => ({
      activePermission: value,
    })),
  setUser: (value) =>
    set(() => ({
      user: value,
      permission: value?.roles?.[0]?.permission || [],
      configProcess: false,
    })),
}));
